import { render, staticRenderFns } from "./EducationalVideo.vue?vue&type=template&id=7f47480a&"
import script from "./EducationalVideo.vue?vue&type=script&lang=js&"
export * from "./EducationalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports